import { call, put, takeEvery } from 'redux-saga/effects';
import {
  fetchTeamDirectoryRequest,
  fetchTeamDirectorySuccess,
  fetchTeamDirectoryFailure,
} from './slice';
import { TeamSection } from '../types';
import { fetchTeamDirectoryConfig } from 'services/teamDirectoryService';
import { reactToastify, ToastType } from 'utility/reactToastify';

function* callToFetchTeamDirectory() {
  try {
    const response: TeamSection[] = yield call(fetchTeamDirectoryConfig);
    if (Array.isArray(response)) {
      yield put(fetchTeamDirectorySuccess(response));
    } else {
      yield put(fetchTeamDirectoryFailure('Invalid data format received'));
      reactToastify({ type: ToastType.error, message: "Failed to load team directory", description: "Unable to fetch team directory data." });
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message ||
                        error?.message ||
                        'Failed to fetch team directory';
    yield put(fetchTeamDirectoryFailure(errorMessage));
    reactToastify({ type: ToastType.error, message: "Failed to load team directory", description: "Unable to fetch team directory data." });
  }
}

export function* callToFetchTeamDirectoryWatcher() {
  yield takeEvery(fetchTeamDirectoryRequest.type, callToFetchTeamDirectory);
}
